import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Sheet',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M3.4 1v22h17.3V1H3.4zm1.3 1.3h14.7v14.4h-4.9v5H4.7V2.3zM18.5 18l-2.7 2.8V18h2.7zm-1.8 3.7l2.7-2.8v2.8h-2.7zm1.1-17.9H6.2v6h11.6v-6zm-1.3 4.7h-9V5.1h9v3.4zM6.3 11.4h4.9v1.3H6.3v-1.3zm0 2.5h4.9v1.3H6.3v-1.3zm0 2.5h4.9v1.3H6.3v-1.3zm0 2.6h4.9v1.3H6.3V19zm6.5-7.6h4.9v1.3h-4.9v-1.3zm0 2.5h4.9v1.3h-4.9v-1.3z" }
      })]
    );
  }
};